import { render, staticRenderFns } from "./my-answers.vue?vue&type=template&id=345d2cee&scoped=true"
import script from "./my-answers.vue?vue&type=script&lang=js"
export * from "./my-answers.vue?vue&type=script&lang=js"
import style0 from "./my-answers.vue?vue&type=style&index=0&id=345d2cee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d2cee",
  null
  
)

export default component.exports